import React from 'react';
import { RefreshCw } from 'lucide-react';
import { formatTime } from './utils';

interface VideoControlsProps {
  currentTime: number;
  duration: number;
  currentFrame: number;
  hasError: boolean;
  onReset: () => void;
}

const VideoControls: React.FC<VideoControlsProps> = ({
  currentTime,
  duration,
  currentFrame,
  onReset,
}) => {
  return (
    <div className="flex items-center justify-between space-x-4">
      <span className="text-sm text-gray-300">
        {formatTime(currentTime)} / {formatTime(duration)}
      </span>
      <div className="flex items-center space-x-2">
        <button
          onClick={onReset}
          className="p-2 hover:bg-gray-700 active:bg-gray-600 rounded-full touch-manipulation text-white flex items-center space-x-1"
        >
          <RefreshCw className="w-5 h-5" />
          <span>再読み込み</span>
        </button>
      </div>
      <div className="text-sm text-gray-300">
        Frame: {currentFrame}
      </div>
    </div>
  );
};

export default VideoControls;